import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f14fa55c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ring-container"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"ring-wrapper\" data-v-f14fa55c><div class=\"donut-hole\" data-v-f14fa55c></div><div class=\"sectors-wrapper\" data-v-f14fa55c><div class=\"sector\" data-v-f14fa55c></div><div class=\"sector\" data-v-f14fa55c></div></div></div>", 1);

const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}